import React from "react";
import { Button, Container, Text } from "theme-ui";
import moment from "moment";
import { BlockscoutTxLink } from "components/Links";
import { SummaryTable } from "components/SummaryTable";
import { GrayBox } from "components/GrayBox";
import { humanFriendlyNumber } from "utils/number";
import { useRecoilState } from "recoil";
import { completeRequestTxHash } from "../state";
import { shortenAccount } from "utils/account";
import { useRequestParams } from "hooks/useRequestParams";
import { fromWei } from "web3-utils";
import { NETWORK_COST } from "config";
import { WalletGlobal } from "hooks/useWallet";

interface IProps {
  onDoneClick: () => void;
}

export const CompleteRequestReceipt: React.FC<IProps> = ({ onDoneClick }) => {
  const { amount: amountWei, currency } = useRequestParams();
  const { gasCurrency, address } = WalletGlobal.useContainer();
  const [txHash] = useRecoilState(completeRequestTxHash);

  if (!amountWei || !currency) {
    return <Text>Invalid completeRequest request</Text>;
  }
  const amount = fromWei(amountWei); // TODO: Assumes wei

  return (
    <Container>
      <Text sx={{ display: "block", mb: 1 }} variant="subtitle">
        Alakazam!
      </Text>
      <Text sx={{ display: "block", mb: 4 }} variant="regular">
        You have fulfilled the request.{" "}
        <BlockscoutTxLink tx={txHash}>View transaction</BlockscoutTxLink>.
      </Text>

      <GrayBox>
        <Text sx={{ mb: 3 }} variant="subtitle">
          Receipt
        </Text>
        <br />
        <SummaryTable
          title="Transaction"
          lineItems={[
            {
              label: "Time completed",
              value: moment().format("h:mm a"),
            },
            {
              label: "Account",
              value: shortenAccount(address),
            },
            {
              label: "Est. total amount",
              value:
                currency === gasCurrency
                  ? `${humanFriendlyNumber(
                      Number(amount) + Number(NETWORK_COST)
                    )} ${gasCurrency}`
                  : `${humanFriendlyNumber(
                      amount
                    )} ${currency} + ${humanFriendlyNumber(
                      NETWORK_COST
                    )} ${gasCurrency}`,
            },
          ]}
          totalItem={{
            label: "Completed Request",
            value: `${humanFriendlyNumber(amount)} ${currency}`,
          }}
        />
      </GrayBox>

      <Button sx={{ mt: 2, px: 6 }} variant="done" onClick={onDoneClick}>
        Done
      </Button>
    </Container>
  );
};
